import { render, staticRenderFns } from "./BasicDetailsEdit.vue?vue&type=template&id=308f268a"
import script from "./BasicDetailsEdit.vue?vue&type=script&lang=js"
export * from "./BasicDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports